import { Box, Button, Flex, Text } from '@chakra-ui/react';
import MailIcon from 'components/singIn/MailIcon';
import Subtitle from 'components/singIn/Subtitle';
import Title from 'components/singIn/Title';
import { ReactNode, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import AuthService from 'api/services/AuthService';
import useRedirectURL from 'hooks/useRedirectURL';
import { ROUTES } from 'routes';

dayjs.extend(duration);

type TProps = {
    title: string;
    subtitle: string | ReactNode;
    back?: ReactNode;
    email: string;
};

const formatTime = (time: any) => {
    const minutes = String(time.minutes()).padStart(2, '0');
    const seconds = String(time.seconds()).padStart(2, '0');
    return `${minutes}:${seconds}`;
};

const timer = dayjs.duration(1, 'minutes');

const SecondState = ({ title, subtitle, back, email }: TProps) => {
    const url = useRedirectURL(ROUTES.reset_password.fullPath);
    const [loading, setLoading] = useState(false);
    const [timeLeft, setTimeLeft] = useState(timer);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                const newTime = prevTime.subtract(1, 'second');
                if (newTime.asSeconds() <= 0) {
                    setDisabled(false);
                    clearInterval(interval);
                    return dayjs.duration(0); // Остановим таймер на нуле
                }
                return newTime;
            });
        }, 1000);

        return () => clearInterval(interval); // Очищаем интервал при размонтировании компонента
    }, []);

    const time = formatTime(timeLeft);

    const handleClick = async () => {
        try {
            setLoading(true);
            await AuthService.resetSend({ email, url })
                .then(response => {
                    setTimeLeft(timer);
                    setDisabled(true);
                    console.log('response', response);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            return false;
        }
    };

    return (
        <Box mt={back ? '0' : '-88px'}>
            {!!back && back}
            <MailIcon />
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
            <Flex justifyContent="space-between" alignItems="center">
                <Button variant="outline" isDisabled={disabled} onClick={handleClick}>
                    Resend email
                </Button>
                <Flex alignItems="center" gap="8px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M5.99967 12.3334H9.99967M4.39967 1.33337H11.5997C11.973 1.33337 12.1597 1.33337 12.3023 1.40604C12.4278 1.46995 12.5298 1.57194 12.5937 1.69738C12.6663 1.83999 12.6663 2.02667 12.6663 2.40004V3.78305C12.6663 4.10917 12.6663 4.27223 12.6295 4.42568C12.5968 4.56173 12.543 4.69179 12.4699 4.81109C12.3874 4.94564 12.2721 5.06094 12.0415 5.29155L10.0873 7.24579C9.82324 7.50981 9.69124 7.64181 9.64178 7.79403C9.59827 7.92793 9.59827 8.07216 9.64178 8.20605C9.69124 8.35827 9.82324 8.49028 10.0873 8.75429L12.0415 10.7085C12.2721 10.9391 12.3874 11.0544 12.4699 11.189C12.543 11.3083 12.5968 11.4384 12.6295 11.5744C12.6663 11.7278 12.6663 11.8909 12.6663 12.217V13.6C12.6663 13.9734 12.6663 14.1601 12.5937 14.3027C12.5298 14.4281 12.4278 14.5301 12.3023 14.594C12.1597 14.6667 11.973 14.6667 11.5997 14.6667H4.39967C4.02631 14.6667 3.83962 14.6667 3.69701 14.594C3.57157 14.5301 3.46959 14.4281 3.40567 14.3027C3.33301 14.1601 3.33301 13.9734 3.33301 13.6V12.217C3.33301 11.8909 3.33301 11.7278 3.36985 11.5744C3.40251 11.4384 3.45638 11.3083 3.52949 11.189C3.61194 11.0544 3.72724 10.9391 3.95785 10.7085L5.91209 8.75429C6.17611 8.49028 6.30811 8.35827 6.35757 8.20605C6.40108 8.07216 6.40108 7.92793 6.35757 7.79403C6.30811 7.64181 6.1761 7.5098 5.91209 7.24579L3.95785 5.29155C3.72725 5.06094 3.61194 4.94564 3.52949 4.81109C3.45638 4.69179 3.40251 4.56173 3.36985 4.42568C3.33301 4.27223 3.33301 4.10917 3.33301 3.78305V2.40004C3.33301 2.02667 3.33301 1.83999 3.40567 1.69738C3.46959 1.57194 3.57157 1.46995 3.69701 1.40604C3.83962 1.33337 4.02631 1.33337 4.39967 1.33337Z"
                            stroke="#0C0A09"
                            strokeWidth="1.33"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <Text color="gray.900" fontSize="14px" fontWeight={500} minWidth="100px">
                        Resend in {time}
                    </Text>
                </Flex>
            </Flex>
        </Box>
    );
};

export default SecondState;
